import React from 'react';
import { useExtCustomColumns } from '../../contexts/extractions/ExtCustomColumnContext';
import StepTitle from './StepTitle';
import { useSelector } from 'react-redux';

const ExtSectionHeader = ({ stepVal }) => {
  const { openModal } = useSelector((state) => state.ExtCustomColumns);
  const { setOpenCustomColumnDrawer } = useExtCustomColumns();

  return (
    // 👇 relative so the bar can anchor to the bottom edge
    <div className="bg-primary px-6 py-3 relative overflow-visible">
      {stepVal === 3 ? (
        <StepTitle
          stepVal={stepVal}
          drawerOpen={openModal}
          closeDrawer={() => setOpenCustomColumnDrawer(false)}
        />
      ) : (
        <StepTitle stepVal={stepVal} />
      )}
    </div>
  );
};

export default ExtSectionHeader;